import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplicationDocuments } from '../../models/application-menu/application-document';
import { ISubmitInspectionResult } from '../../models/inspection/SubmitInspectionResult';
import { environment } from '@env/environment';
import { IDropdowns } from 'app/models/core/dropdowns';
import { IAssessment, IInspection, IInspectionCorrectiveAction, IInspectionInspector, IInspectionMethodRef, IInspectionQuestion, IInspectionTechnology } from 'app/models/inspection/inspection';
import { IInspectionSummaryViewModel } from 'app/models/report/reports';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const HTTPOptionsText:Object = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json'
  }),
  responseType: 'text'
}

@Injectable({
  providedIn: 'root',
})

export class InspectionService {

  @Output() updateEvent = new EventEmitter<number>();

  newInspect: boolean = true;
  refresh: boolean = false;
  inspectionSetup: boolean = true;
  currentInspector: number = 0;
  currentChecklist: number = 0;
  currentCa: IInspectionCorrectiveAction = null;
  currentTab: number = 0;
  assessment: IAssessment = { 
    appId: 0,  
    labId: 0,
    user: '',
    labName: '',
    orelapId: '',
    newInspectionFlag: true,
    inspectionID: 0,
    referenceApp: '',
  
    inspection: null,
    ca: [],
    inspectionTechs: [],
    inspectionMethods: [],
    documents: [],
    inspectors: [],

    inspectorList: [],
    checkList: [],
    questionGroups: [],
    correctiveActionTypes: []
  };
  inspectionDocuments: IApplicationDocuments[] = [];

  private api: string = environment.privateApi + 'Assessment/';
  private reportApi: string = environment.privateApi + 'Reports/';

  constructor(private http: HttpClient) {}

  resetAssessment(){
    this.newInspect = true;
    this.refresh = false;
    this.currentInspector = 0;
    this.currentCa = null;
    this.currentTab = 0;
    this.inspectionSetup = true;

    this.inspectionDocuments = [];

    this.assessment.appId = 0;  
    this.assessment.labId = 0,
    this.assessment.user = '',
    this.assessment.labName = '',
    this.assessment.orelapId = '',
    this.assessment.newInspectionFlag = true,
    this.assessment.inspectionID = 0,
    this.assessment.referenceApp = '',
  
    this.assessment.inspection = null,
    this.assessment.ca = [],
    this.assessment.inspectionTechs = [],
    this.assessment.inspectionMethods = [],
    this.assessment.documents = [],
    this.assessment.inspectors = [],

    this.assessment.inspectorList = [],
    this.assessment.checkList = [],
    this.assessment.questionGroups = [],
    this.assessment.correctiveActionTypes = []
  }

  updateTabs(tab:number){
    this.updateEvent.emit(tab);
  }

  getInspectionDocuments(appId: number): Observable<IApplicationDocuments[]> {
    return this.http.get<any>(this.api + 'getInspectionDocs/' + appId , httpOptions);
  }

  getInspectionCAs(appId: number): Observable<IInspectionCorrectiveAction[]> {
    return this.http.get<IInspectionCorrectiveAction[]>(this.api + 'getInspectionCas/' + appId, httpOptions);
  }

  uploadDocuments(files: FormData, appId: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'uploadDocuments/' + appId, files);
  }

  downloadDocument(fileId: number, appId: number): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'downloadDocument/' + fileId + '/' + appId, { responseType: 'blob' as 'json' });
  }

  deleteDocument(documentId: number, appId: number): Observable<any> {
    return this.http.delete<any>(this.api + 'deleteDocument/' + documentId + '/' + appId, httpOptions);
  }

  saveCorrectiveAction(ca: IInspectionCorrectiveAction): Observable<boolean> {
    return this.http.post<boolean>(this.api + "correctiveActionResponse", ca, httpOptions);
  }

  submitInspection(appId: number): Observable<ISubmitInspectionResult> {
    return this.http.post<ISubmitInspectionResult>(this.api + "submitInspection/" + appId, httpOptions);
  }

  // getInspectionSummary(appId: number, labId: number): Observable<Blob> {
  //   return this.http.get<Blob>(this.reportApi + 'getInspectionSummary/' + appId + '/' + labId, { responseType: 'blob' as 'json' });
  // }
  getInspectionSummary(appId: number, labId: number): Observable<IInspectionSummaryViewModel> {
    return this.http.get<IInspectionSummaryViewModel>(this.reportApi + 'getInspectionSummary/' + appId + '/' + labId, httpOptions);
  }

  getInspectionStatus(appId: number): Observable<string> {
    return this.http.get(this.api + 'getInspectionStatus/' + appId, {responseType: 'text'});
  }

  getReportSummary(inspectionId: number): Observable<string> {
    return this.http.get(this.api + 'getReportSummary/' + inspectionId, {responseType: 'text'});
  }

  saveReportSummary(inspectionId: number, insp: IInspection): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveReportSummary/' + inspectionId , insp, httpOptions);
  }

  getApplicationDatesList(orelapId: string): Observable<IDropdowns[]> {
    return this.http.get<IDropdowns[]>(this.api + 'getApplicationDatesList/' + orelapId , httpOptions);
  }

  getInspection(appId: number, labId: number): Observable<IAssessment> {
    return this.http.get<IAssessment>(this.api + "getInspection/" + appId + "/" + labId, httpOptions);
  }

  updateTechInspector(techId:number, inspectorId: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "updateTechInspector/" + techId + "/" + inspectorId, httpOptions);
  }  
  
  updateTechCheckList(techId:number, checkListId: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "updateTechCheckList/" + techId + "/" + checkListId, httpOptions);
  }

  getInspectionTech(inspectionId:number): Observable<IInspectionTechnology[]> {
    return this.http.get<IInspectionTechnology[]>(this.api + "getInspectionTech/" + inspectionId , httpOptions);
  }

  getInspectionTechList(): Observable<IDropdowns[]> {
    return this.http.get<IDropdowns[]>(this.api + "getInspectionTechList" , httpOptions);
  }

  addInspectionTech(inspectionId:number, techKey: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "addInspectionTech/" + inspectionId + "/" + techKey , httpOptions);
  }

  deleteInspectionTech(techId:number): Observable<any> {
    return this.http.get<any>(this.api + "deleteInspectionTech/" + techId , HTTPOptionsText);
  }

  addInspectionMethod(inspectionId:number, techId:number, methodKey:number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "addInspectionMethod/" + inspectionId + '/' + techId +
        '/' + methodKey, httpOptions);
  }

  deleteInspectionMethod(methodId:number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "deleteInspectionMethod/" + methodId , httpOptions);
  }

  getInspectionMethodList(techId: number): Observable<IInspectionMethodRef[]> {
    return this.http.get<IInspectionMethodRef[]>(this.api + "getInspectionMethodList/" + techId , httpOptions);
  }  

  createNewInspection(appId:number, appRefId:number, standard:string, inspectType:string): Observable<boolean> {
    return this.http.get<boolean>(this.api + "createNewInspection/" + appId + "/" + appRefId + "/" + standard + 
        "/" + inspectType, httpOptions);
  }

  getInspectorList(inspId:number): Observable<IInspectionInspector[]> {
    return this.http.get<IInspectionInspector[]>(this.api + "getInspectorList/" + inspId , httpOptions);
  }  

  saveStartStopDates(insp: IInspection): Observable<void> {
    return this.http.post<void>(this.api + "saveStartStopDates", insp, httpOptions);
  }  
  
  closeInspection(inspId: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + "closeInspection/" + inspId,  httpOptions);
  }

  getQuestionsList(techId: number,checklistKey:number, filter: string): Observable<IInspectionQuestion[]> {
    return this.http.get<IInspectionQuestion[]>(this.api + "getQuestionsList/" + techId + "/" + 
        checklistKey + "/" + filter,  httpOptions);
  }

  saveInspectionFindings(techId: number,finding: IInspectionQuestion): Observable<string> {
    return this.http.post<string>(this.api + "saveInspectionFindings/" + techId, finding, HTTPOptionsText);
  }  

  closeInspectionCa(caId: number): Observable<void> {
    return this.http.get<void>(this.api + "closeInspectionCa/" + caId,  httpOptions);
  }

  failInspectionCa(caId: number): Observable<void> {
    return this.http.get<void>(this.api + "failInspectionCa/" + caId,  httpOptions);
  }

  getInspectionUpdate(appId: number): Observable<IInspection> {
    return this.http.get<IInspection>(this.api + "getInspectionUpdate/" + appId,  httpOptions);
  }

  saveInspectionSummaryPdf(appId: number, labId: number, pdfBlob: Blob, fileName: string): Observable<boolean> {
    const formData = new FormData();
    formData.append('file', pdfBlob, fileName);
    formData.append('appId', appId.toString());
    formData.append('labId', labId.toString());
    
    return this.http.post<boolean>(this.reportApi + 'saveInspectionSummaryPdf', formData);
  }

}
